import styled from 'styled-components';
import coloricon from '../../styles/coloricon';

const { fontColor } = coloricon;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10px;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 425px) {
    font-size: 14px;
  }

  @media (max-width: 375px) {
    font-size: 13px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
  }

  > h1 {
    margin: 15px 0px;
  }

  > form {
    width: 80%;
    margin-top: 15px 0px 50px 0px;

    button {
      width: 100%;
    }
  }
`;

export const GroupDate = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

export const OccurrenceTitle = styled.h1`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${fontColor};
  text-transform: uppercase;
  font-size: 1.3em;

  & {
    margin-top: 25px;
  }
`;
